/**
 * This function will format the full name, capitalizing the first letter of each word.
 * @param {string} fullname - The full name.
 * @return {string} The full name with the first letter of each word capitalized.
 */
export function fullNameFormat(fullname) {
  if (typeof fullname === 'string' || fullname instanceof String) {
    const wordList = fullname.split(' ');
    const capitalizedWordList = wordList.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    const find = ',';
    const re = new RegExp(find, 'g');
    return capitalizedWordList.toString().replace(re, ' ');
  }
  throw new Error(
    'The type of variable is not correct, it must be of type string.'
  );
}

import { getFullNameArrayDepure } from './validators';

export function fixMc(str) {
  return str.replace(/\bMc(\w)/, function (match, p1) {
    return match.slice(0, -1) + p1.toUpperCase();
  });
}

export function capitalizeWords(text, options = {}) {
  if (typeof text === 'string' && text.length) {
    const string = text.toLowerCase().trim();
    if (options.firstOnly) {
      return string?.charAt(0)?.toUpperCase() + string?.slice(1);
    }
    return string
      ?.split(' ')
      .map((word) => fixMc(word.charAt(0)?.toUpperCase() + word.slice(1)))
      .join(' ');
  }
  return '';
}

/**
 * This function will format the full name, capitalizing the first letter of each word, but returns an object with first name and last name.
 * @param {string} full_name must be a string otherwise it throws an error
 * @return {string} An object with the first letter of each word capitalized.
 */
export const getFormatFirstAndLastNameArray = (full_name) => {
  const nameSplit = getFullNameArrayDepure(full_name);
  const firstName = nameSplit[0];
  let lastName = '';
  if (nameSplit.length) {
    nameSplit.shift();
    lastName = nameSplit.join(' ');
  }
  return { firstName, lastName };
};

const splitWords = (str) => {
  return str
    .split(' ')
    .map((w) => w.trim())
    .filter((w) => w.length > 0);
};

export const formatFirstLastName = (full_name) => {
  const nameSplit = splitWords(full_name);
  const first_name = nameSplit[0];
  let last_name = nameSplit.slice(1).join(' ');
  return { first_name, last_name };
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return '';
  }
  const formattedNumber = phoneNumber?.replace(/[^0-9]/g, '');
  if (formattedNumber?.length === 11) {
    return formattedNumber?.replace(
      /(\d{1})(\d{3})(\d{3})(\d{4})/,
      '+$1 ($2)-$3-$4'
    );
  } else if (formattedNumber?.length === 12) {
    return formattedNumber?.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})/,
      '+$1 ($2) $3-$4'
    );
  }
  return phoneNumber;
};
